var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: { layout: _vm.layout, model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "试题内容：", prop: "topic" } },
            [
              _c("a-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.form.topic,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "topic", $$v)
                  },
                  expression: "form.topic",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "关联项：", prop: "relevance" } },
            [
              _c("a-select", {
                attrs: {
                  mode: "multiple",
                  placeholder: "请选择关联项",
                  options: _vm.relevanceOptions,
                },
                model: {
                  value: _vm.form.relevance,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "relevance", $$v)
                  },
                  expression: "form.relevance",
                },
              }),
            ],
            1
          ),
          _vm._l(_vm.form.topicOptions, function (item, index) {
            return _c(
              "a-form-model-item",
              {
                key: item.key,
                staticClass: "add-input",
                attrs: {
                  label: index === 0 ? "题目选项：" : "",
                  prop: "topicOptions." + index + ".value",
                  rules: {
                    required: true,
                    message: `题目选项${item.key}不能为空`,
                    trigger: "blur",
                  },
                },
              },
              [
                _c("a-input", {
                  attrs: { "addon-before": item.key, placeholder: "请输入" },
                  model: {
                    value: item.value,
                    callback: function ($$v) {
                      _vm.$set(item, "value", $$v)
                    },
                    expression: "item.value",
                  },
                }),
                index == _vm.form.topicOptions.length - 1 && index > 0
                  ? _c("a-icon", {
                      staticClass: "dynamic-delete-button",
                      style: { fontSize: "22px", color: "#999" },
                      attrs: { type: "delete" },
                      on: {
                        click: function ($event) {
                          return _vm.removeDomain(item)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          _c(
            "a-form-model-item",
            [
              _c(
                "a-button",
                {
                  attrs: { type: "dashed", block: "" },
                  on: { click: _vm.addDomain },
                },
                [_c("a-icon", { attrs: { type: "plus" } }), _vm._v("新增选项")],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("保存")]
              ),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  on: { click: _vm.resetForm },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }